import React, { useState } from "react";
import "./SelectAddressCard.css";
import { Form } from "react-bootstrap";
import Action_Btn from "../../../Common-Component/Common_Btn/Action_Btn/Action_Btn";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import EditAddressModal from "../../../Common-Component/Common_Modal/AddAddressModal/EditAddressModal";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  deleteAddress,
  getAllOrderAddress,
  getAllSippingOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";

const SelectAddressCard = ({
  setSameShippingBilling,
  billingAddressId,
  sameshippingBilling,
  setShippingAddressId,
  setBillingAddressId,
  name,
  val,
  index,
}) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const address = useSelector((state) => state.order.orderAddress);
  const dispatch = useDispatch();
  const [data, setData] = useState(false);

  const GetData = async (id) => {
    try {
      const res = await dispatch(getSingleOrderAddress(id));

      setData(res?.payload?.data);
      setShowEditModal(true);
    } catch (error) {}
  };

  const ShippingAddress = (id) => {
    setShippingAddressId(id);
  };

  const BillingAddress = (id) => {
    setBillingAddressId(id);
    setSameShippingBilling(false);
  };

  const deletSubmit = async (data) => {
    // if()

    const res = await dispatch(deleteAddress(data));
    dispatch(getAllOrderAddress());
    dispatch(getAllSippingOrderAddress());
    // if (res?.payload?.errors) {
    //     setError("pincode", {
    //         type: "manual",
    //         message: res.payload?.errors,
    //       });
    //   }else{
    //     setshowUploadModal(true);
    //   }
  };

  return (
    <section className="SelectAddressCard">
      <div className="select_address_div">
        <div className="top_card_part">
          <div className="left_side">
            {name ? (
              <div className="name_radio_div ">
                <Form.Check
                  type="radio"
                  name="Radio"
                  id="nameRadio"
                  className="radio_div"
                  defaultChecked={index === 0}
                  onChange={() => ShippingAddress(val.id)}
                />
                <p className="name_text mb-0">{val?.name}</p>
              </div>
            ) : (
              <div className="name_radio_div ">
                <Form.Check
                  type="radio"
                  name="nameRadio"
                  id="nameRadio"
                  className="radio_div"
                  onChange={() => BillingAddress(val.id)}
                  disabled={sameshippingBilling}
                  checked={billingAddressId === val.id && !sameshippingBilling}
                  //   defaultChecked={index === 0}
                />
                <p className="name_text mb-0">{val?.name}</p>
              </div>
            )}

            {/* {
              (nama = "Biiling" && (
                <div className="name_radio_div ">
                  <Form.Check
                    type="radio"
                    name="nameRadio"
                    id="nameRadio"
                    className="radio_div"
                    defaultChecked={index === 0}
                  />
                  <p className="name_text mb-0">{val?.name}</p>
                </div>
              ))
            } */}

            <div
              className="action_btn_holder"
            
            >
              <div className="delete_btn"   onClick={() => deletSubmit(val?.id)}>
                <Action_Btn btn_name="Delete" icon={faTrash} />
              </div>

              <div
                className="edit_btn"
                onClick={() => {
                  GetData(val?.id);
                }}
              >
                <Action_Btn btn_name="Edit" icon={faPenToSquare} />
              </div>
            </div>
          </div>
        </div>

        <div className="address_test_div">
          <p className="address">
            {val?.company_name}, {val?.address_one},{val?.address_two},{" "}
            {val?.Country?.name}, {val?.State?.name}, {val?.City?.name}
            {val?.Pincode?.name}
          </p>
        </div>
      </div>
      <EditAddressModal
        data={data}
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
        }}
      />
    </section>
  );
};

export default SelectAddressCard;
